import React from 'react';
import { CodeSnippet, Button } from 'carbon-components-react';
import { CheckmarkOutline20 } from '@carbon/icons-react';

const DisplaySuccess = ({ apikey, handleDone }: any) => {
  const handleCopySecretButton = () =>
    navigator.clipboard.writeText(apikey.clientSecret);
  const handleCopyIdButton = () =>
    navigator.clipboard.writeText(apikey.clientId);

  return (
    <div className="apikey-modal">
      <div className="apikey-modal-main">
        <div className="apikey-wrapper">
          <div className="apikey-modal-success-wrapper">
            <div className="apikey-modal-success">Success</div>
            <CheckmarkOutline20 />
          </div>
          <hr className="section--divider" />
          <div className="apikey-modal-disclaimer">
            <div className="apikey-modal-disclaimer-item">
              A new API key was generated
            </div>
            <div className="apikey-modal-disclaimer-item">
              For security reasons, the <span>client secret</span> will not be
              displayed again so copy it now and treat it like a password.
            </div>
          </div>
          <hr className="section--divider" />
          <div className="apikey-modal-clientid">Client ID</div>
          <CodeSnippet
            className="apikey-code-snippet-clientid"
            onClick={handleCopyIdButton}
            type="single"
          >
            {apikey.clientId}
          </CodeSnippet>
          <div className="apikey-modal-client-secret">Client secret</div>
          <CodeSnippet
            type="multi"
            className="apikey-code-snippet-secret"
            onClick={handleCopySecretButton}
          >
            {apikey.clientSecret}
          </CodeSnippet>
        </div>
        <Button onClick={handleDone}>Done</Button>
      </div>
    </div>
  );
};

DisplaySuccess.displayName = 'DisplaySuccess';
export default DisplaySuccess;
